const TOOLBAR_ID = '__POSTHOG_TOOLBAR__';
const TOOLBAR_CONTAINER_CLASS = 'toolbar-global-fade-container';
const SDK_DIST_CHANNEL = '$sdk_dist_channel';
export { SDK_DIST_CHANNEL, TOOLBAR_CONTAINER_CLASS, TOOLBAR_ID };
